<!-- Tabs.vue -->
<template>
  <div class="tabs"
       ref="tabs"
  >
    <div class="tab-nav">
      <div class="tab-name"
          v-for="(tab, index) in tabPanes"
          :key="index"
          @click="selectTab(tab.name)"
          :class="{ active: selected === tab.name }"
          ref="tabRefs"
      >
        {{ tab.label }}
      </div>
      <div class="slider" :style="{ left: `${sliderPosition}px`, width: `${sliderWidth}px`}"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  data() {
    return {
      selected: null,
      sliderPosition: 0,
      sliderWidth: 0,
      tabPanes: []
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init () {
      // 初始化tabPanes数组，假设每个TabPane都有一个name和label属性
      this.tabPanes = this.$slots.default.filter(vnode => vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'TabPane').map(vnode => ({
        name: vnode.componentOptions.propsData.name,
        label: vnode.componentOptions.propsData.label
      }));

      // 默认情况下选中第一个TabPane
      if (this.tabPanes.length > 0) {
        this.selectTab(this.tabPanes[0].name)
      }
    },
    updateSliderPosition() {
      try {
        const tabRefs = this.$refs.tabRefs;
      // 遍历已选中tab之前的所有tab，并累加它们的宽度
      for (let i = 0; i < tabRefs.length; i++) {
        if (tabRefs[i].classList.contains('active')) {
          const {left, width} = tabRefs[i]?.getBoundingClientRect();
          this.sliderPosition = left - this.$refs.tabs?.getBoundingClientRect().left ;
          this.sliderWidth = width;
          break
        }
      }
      } catch (error) {
        console.log(error)
      }


      // 考虑到可能的内边距、外边距或边框，你可能需要调整totalWidth的值
    },
    selectTab(name) {
      this.selected = name;
      this.notifyTabPanes();
      this.$nextTick().then(() => this.updateSliderPosition())
    },
    notifyTabPanes() {
      this.$slots.default.forEach(vnode => {
        if (vnode.componentInstance && vnode.componentInstance.$options.name === 'TabPane') {
          vnode.componentInstance.isSelected = this.selected === vnode.componentOptions.propsData.name;
        }
      });
    }
  },
};
</script>

<style scoped>
.tab-nav {
  position: relative;
  margin: 24px 0;
  overflow-x: scroll;
  white-space: nowrap;
}
.tab-nav .tab-name {
  position: relative;
  margin-right: 30px;
  display: inline-block;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.24px;
  line-height: 20px;
  color: rgba(128, 128, 128, 1);
  text-align: left;
  vertical-align: top;
  z-index: 1
}
.tab-nav .tab-name:last-child {
  margin-right: 0;
}
.tab-nav .tab-name.active {
  color: rgba(35, 35, 35, 1);
}
.slider {
  position: absolute;
  bottom: 0;
  height: 6px;
  border-radius: 8px;
  background: rgba(207, 236, 255, 1);
  transition: left .3s ease, width .3s ease;
}

</style>